export default "__VITE_ASSET__84bfb654__"